import { useState, useEffect } from 'react'
import { Row, Col, Spinner, Alert, Pagination } from 'react-bootstrap'
import client from '../../api/client'
import ModelCard from '../../components/ModelCard'
import ModelFilters from '../../components/ModelFilters'

function ModelCatalog() {
  const [models, setModels] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const perPage = 12

  const providers = ['openrouter', 'novita', 'together', 'local']

  useEffect(() => {
    fetchModels()
  }, [filters, page])

  const fetchModels = async () => {
    setLoading(true)
    try {
      const params = new URLSearchParams()
      if (filters.search) params.append('search', filters.search)
      if (filters.provider) params.append('provider', filters.provider)
      if (filters.type) params.append('type', filters.type)
      if (filters.active) params.append('active', filters.active)
      params.append('limit', perPage)
      params.append('offset', (page - 1) * perPage)

      const response = await client.get(`/admin/api/v1/models/?${params}`)
      setModels(response.data.models || [])
      setTotal(response.data.total || 0)
    } catch (err) {
      setError('Erreur lors du chargement des modèles')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  const handleAddModel = async (model) => {
    try {
      await client.patch(`/admin/api/v1/models/${model.id}`, { active: true })
      fetchModels()
    } catch (err) {
      setError('Erreur lors de l\'activation du modèle')
    }
  }

  const handleRemoveModel = async (model) => {
    try {
      await client.patch(`/admin/api/v1/models/${model.id}`, { active: false })
      fetchModels()
    } catch (err) {
      setError('Erreur lors de la désactivation du modèle')
    }
  }

  const totalPages = Math.ceil(total / perPage)

  return (
    <div>
      <h1 className="h3 mb-4">Catalogue de modèles</h1>

      <ModelFilters
        filters={filters}
        onFilterChange={setFilters}
        providers={providers}
      />

      {error && <Alert variant="danger" dismissible onClose={() => setError('')}>{error}</Alert>}

      {loading ? (
        <div className="d-flex justify-content-center p-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : models.length === 0 ? (
        <Alert variant="info">Aucun modèle trouvé</Alert>
      ) : (
        <>
          <Row className="g-4">
            {models.map((model) => (
              <Col key={model.id} md={6} lg={4} xl={3}>
                <ModelCard
                  model={model}
                  onAdd={handleAddModel}
                  onRemove={handleRemoveModel}
                />
              </Col>
            ))}
          </Row>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <Pagination>
                <Pagination.Prev
                  disabled={page === 1}
                  onClick={() => setPage(page - 1)}
                />
                {[...Array(Math.min(totalPages, 5))].map((_, i) => (
                  <Pagination.Item
                    key={i + 1}
                    active={page === i + 1}
                    onClick={() => setPage(i + 1)}
                  >
                    {i + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  disabled={page === totalPages}
                  onClick={() => setPage(page + 1)}
                />
              </Pagination>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default ModelCatalog
